import { useEffect, useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import { APILA } from "../../../../../../config/apila";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";

import "bulma/css/bulma.css";
import "../../../../../../index.css";

export default function ModalUpdateKategoriPenilai(props) {
  const token = localStorage.getItem("token");
  const idUser = (
    localStorage.getItem("id_admin") ||
    localStorage.getItem("user_id") ||
    ""
  ).replace(/[|&;$%@"<>()+,]/g, "");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form, setForm] = useState({
    ysb_academic_year_id: "",
    ysb_semester_id: "",
    nama: "",
    bobot: "",
  });

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const semesterByActiveYear = useMemo(() => {
    const activeYearId = props?.activeAcademicYear?.id;
    const options = Array.isArray(props?.semesterOptions)
      ? props.semesterOptions
      : [];

    if (!activeYearId) return [];

    return options
      .filter(
        (item) =>
          String(item?.ysb_academic_year_id) === String(activeYearId)
      )
      .sort(
        (first, second) =>
          Number(first?.semester || 0) - Number(second?.semester || 0)
      );
  }, [props?.activeAcademicYear?.id, props?.semesterOptions]);

  useEffect(() => {
    if (!props.show || !props.dataUpdate) return;

    const activeYearId = props?.activeAcademicYear?.id || "";

    const dataSemester = semesterByActiveYear.find(
      (item) =>
        String(item?.id) === String(props.dataUpdate?.ysb_semester_id || "")
    );

    const currentSemester = semesterByActiveYear.find(
      (item) => String(item?.id) === String(props?.currentSemesterId || "")
    );

    const activeSemester = semesterByActiveYear.find(
      (item) =>
        String(item?.id) ===
        String(props?.activeAcademicYear?.activeSemesterId || "")
    );

    const defaultSemester =
      dataSemester ||
      currentSemester ||
      activeSemester ||
      semesterByActiveYear[0];

    setForm({
      ysb_academic_year_id: activeYearId,
      ysb_semester_id: defaultSemester?.id || "",
      nama: props.dataUpdate?.nama || "",
      bobot: props.dataUpdate?.bobot ?? "",
    });
  }, [
    props.show,
    props.dataUpdate,
    props?.activeAcademicYear?.id,
    props?.activeAcademicYear?.activeSemesterId,
    props?.currentSemesterId,
    semesterByActiveYear,
  ]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const academicYearId = form.ysb_academic_year_id;
    const semesterId = form.ysb_semester_id;
    const nama = form.nama.trim();
    const bobot = String(form.bobot).trim();

    if (!props.id) {
      ToastError.fire({
        icon: "error",
        title: "ID kategori penilai tidak ditemukan",
      });
      return;
    }

    if (!academicYearId) {
      ToastError.fire({
        icon: "error",
        title: "Tahun ajaran aktif tidak ditemukan",
      });
      return;
    }

    if (!semesterId) {
      ToastError.fire({
        icon: "error",
        title: "Semester wajib dipilih",
      });
      return;
    }

    if (!nama) {
      ToastError.fire({
        icon: "error",
        title: "Nama kategori penilai wajib diisi",
      });
      return;
    }

    if (bobot === "" || Number.isNaN(Number(bobot))) {
      ToastError.fire({
        icon: "error",
        title: "Bobot wajib diisi dengan angka",
      });
      return;
    }

    if (Number(bobot) < 0) {
      ToastError.fire({
        icon: "error",
        title: "Bobot tidak boleh kurang dari 0",
      });
      return;
    }

    if (!idUser) {
      ToastError.fire({
        icon: "error",
        title: "User ID tidak ditemukan. Silakan login ulang.",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await APILA.put(
        `/api/categories-penilai/${props.id}`,
        {
          ysb_academic_year_id: academicYearId,
          ysb_semester_id: semesterId,
          nama,
          bobot,
          user_id: idUser,
        },
        fetchParams
      );

      if (response?.data?.error) {
        throw new Error(response?.data?.message || "Gagal memperbarui data");
      }

      if (response?.status === 200 || response?.status === 201) {
        ToastSuccess.fire({
          icon: "success",
          title:
            response?.data?.message ||
            "Kategori penilai berhasil diperbarui",
        });

        if (props.onSaved) {
          await props.onSaved({
            ysb_academic_year_id: academicYearId,
            ysb_semester_id: semesterId,
          });
        } else {
          await props.GetResponseData?.();
        }

        props.onHide?.();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          error?.message ||
          "Gagal memperbarui kategori penilai",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="module-modal-dialog"
      contentClassName="module-modal-content"
    >
      <form onSubmit={handleSubmit}>
        <div className="module-modal-header">
          <div>
            <h5 className="module-modal-title">Update Kategori Penilai</h5>
            
          </div>

          <button
            type="button"
            className="module-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <Modal.Body className="module-modal-body mt-1 mx-2">
          <div className="module-form-grid">
            <div className="module-form-group">
              <label
                className="module-form-label"
                htmlFor="update-kategori-penilai-tahun-ajaran"
              >
                Tahun Ajaran <span>*</span>
              </label>
              <input
                id="update-kategori-penilai-tahun-ajaran"
                type="text"
                className="module-form-input"
                value={props?.activeAcademicYear?.name || "-"}
                disabled
              />
            </div>

            <div className="module-form-group">
              <label
                className="module-form-label"
                htmlFor="update-kategori-penilai-semester"
              >
                Semester <span>*</span>
              </label>
              <select
                id="update-kategori-penilai-semester"
                className="module-form-input"
                name="ysb_semester_id"
                value={form.ysb_semester_id}
                onChange={handleChange}
                disabled={isSubmitting || semesterByActiveYear.length === 0}
              >
                <option value="">Pilih Semester</option>
                {semesterByActiveYear.map((item) => (
                  <option key={item?.id} value={item?.id}>
                    {item?.semester
                      ? `Semester ${item.semester}`
                      : item?.name || "Semester"}
                  </option>
                ))}
              </select>
            </div>

            <div className="module-form-group module-form-span-2">
              <label
                className="module-form-label"
                htmlFor="update-kategori-penilai-nama"
              >
                Nama Kategori Penilai <span>*</span>
              </label>
              <input
                id="update-kategori-penilai-nama"
                type="text"
                className="module-form-input"
                name="nama"
                value={form.nama}
                onChange={handleChange}
                
                autoFocus
                disabled={isSubmitting}
                maxLength={150}
              />
            </div>

            <div className="module-form-group module-form-span-2">
              <label
                className="module-form-label"
                htmlFor="update-kategori-penilai-bobot"
              >
                Bobot <span>*</span>
              </label>
              <input
                id="update-kategori-penilai-bobot"
                type="number"
                className="module-form-input"
                name="bobot"
                value={form.bobot}
                onChange={handleChange}
                
                min="0"
                step="any"
                disabled={isSubmitting}
              />
            </div>
          </div>
        </Modal.Body>

        <div className="module-modal-footer">
          <button
            type="button"
            className="module-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="module-modal-submit"
            disabled={
              isSubmitting ||
              !form.ysb_academic_year_id ||
              !form.ysb_semester_id
            }
          >
            {isSubmitting && <span className="module-button-spinner" />}
            {isSubmitting ? "Memperbarui..." : "Perbarui"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
